import { render, staticRenderFns } from "./LegalForm.vue?vue&type=template&id=46fd3b76&scoped=true"
import script from "./LegalForm.vue?vue&type=script&lang=js"
export * from "./LegalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fd3b76",
  null
  
)

export default component.exports